// extracted by mini-css-extract-plugin
export default {"rangeLabel":"inputSlider_rangeLabel__mEZfF","sliderTable":"inputSlider_sliderTable__H7Va2","slider":"inputSlider_slider__Z06ka"};